import React from "react";
import {formatDate} from "../helpers/util";
import Bilde from "./Bilde";


const Mentalbeskrivelse = (props) => {
    const mentalbeskrivelse = props.mentalbeskrivelse;
    if (mentalbeskrivelse === null) {
        return <div className="dogweb-card"></div>
    }
    const rows = mentalbeskrivelse.momentResultatList.map((moment) => (
        <tr key={moment.id} >
            <td className="test-type">{moment.navn}</td>
            <td>{moment.resultat}</td>
            <td>{moment.oenskeProfilResultat}</td>
        </tr>
    ));

    const spindelUrl = mentalbeskrivelse.spindelDiagram.url;
    return (
        <div>

            <div className="dogweb-card">
                <p><label>Test dato:</label> {formatDate(mentalbeskrivelse.testDato)}</p>
                <p><label>Reg dato:</label> {formatDate(mentalbeskrivelse.registrertDato)}</p>
                <p><label>Alder måneder:</label> {mentalbeskrivelse.alderMndVedTest}</p>


                {
                    mentalbeskrivelse.beskriver1 !== null &&
                    <p><label>Team: </label>{mentalbeskrivelse.beskriver1} (beskriver)</p>
                }
                {
                    mentalbeskrivelse.beskriver2 !== null &&
                    <p><label>2.</label> {mentalbeskrivelse.beskriver2}</p>
                }
                {
                    mentalbeskrivelse.beskriver3 !== null &&
                    <p><label>3.</label> {mentalbeskrivelse.beskriver3}</p>
                }
                {
                    mentalbeskrivelse.beskriver4 !== null &&
                    <p><label>4.</label> {mentalbeskrivelse.beskriver4}</p>
                }
                {
                    mentalbeskrivelse.kommentar !== null &&
                    <p><label>Kommentar:</label> {mentalbeskrivelse.kommentar}</p>
                }
                <p><label>Ref.NR:</label> {mentalbeskrivelse.proeveId}</p>
                {
                    mentalbeskrivelse.avbrutt &&
                    <p>
                        <font color="#FF0000">
                            Test afbrudt
                            {
                                mentalbeskrivelse.bit &&
                                    <span><br />Bid</span>
                            }
                            {
                            mentalbeskrivelse.flykterFraPlassen &&
                                    <span><br />Flygter fra pladsen</span>
                            }
                            {
                                mentalbeskrivelse.kanIkkeFortsette &&
                                    <span><br />Kan ikke fortsætte</span>
                            }
                            {
                                mentalbeskrivelse.annenAarsak &&
                                    <span><br />Anden årsag</span>
                            }
                        </font>
                    </p>

                }
                {
                    mentalbeskrivelse.avlsforbud &&
                    <p>
                        <font color="#FF0000">Avlsforbud</font>
                    </p>

                }

            </div>
            <table className="table-mentaltest">
                <thead>
                <tr>
                    <th className="test-type" width="100%">Type</th>
                    <th width="60px">Resultat</th>
                    <th width="60px">Ønske profil</th>
                </tr>
                </thead>
                <tbody>
                    { rows }
                </tbody>
            </table>

            <Bilde url={spindelUrl}  className="spindel"
                   heroimage={false}/>
            <p>
                <a href={mentalbeskrivelse.spindelDiagramStatistikkUrl} rel="noopener noreferrer" className="link-spindeldiagram" target="_blank">
                    Generer racens profil og gennemsnit
                </a>
            </p>
        </div>

    );




};
export default  Mentalbeskrivelse;
